import Vue from 'vue';

const pdpModule = {
  namespaced: true,

  state: {
    pdpSku: 0,
    priceData: {},
    isBike: false,
  },
  getters: {
    pdpBaseProductId: (state) => {
      const el = document.getElementById('base-code');
      if (!el) return null;

      return el.value;
    },
  },

  mutations: {
    setPdpSku(state, pdpSku) {
      Vue.set(state, 'pdpSku', pdpSku);
    },

    setPriceData(state, payload) {
      Vue.set(state, 'priceData', payload);
    },

    setIsBike(state, payload) {
      state.isBike = payload;
    },
  },

  actions: {
    setVariantPdpSku({commit}, pdpSku) {
      commit('setPdpSku', pdpSku);
    },

    setVariantPrice({commit}, priceData) {
      commit('setPriceData', priceData);
    },
  },
};

export default pdpModule;
